import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {AgentFilterResult} from './agent-filter-result';
import {Agent} from 'src/app/agent/component/service/agent.model';
import { TramsDataSourceModel } from '../../../payments/models/trams-data-source';
import { HttpClient } from '@angular/common/http';

@AutoUnsubscribe()
@Component({
    selector: 'agent-filter-modal',
    templateUrl: './agent-filter-modal.component.html',
    standalone: false
})
export class AgentFilterModalComponent implements OnInit {
  config: AgentFilterResult;
  title: string;
  agentData: Agent;

  form: FormGroup = new FormGroup({
    agentName: new FormControl(null),
    agentCode: new FormControl(null),
    dataSourceId: new FormControl(null)
  });

  public datasources: TramsDataSourceModel[] = [];

  constructor(
    @Optional() public dialogRef: MatDialogRef<AgentFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { config: AgentFilterResult, title: string, agentData: Agent },
    private http: HttpClient
  ) {
    this.config = data.config;
    this.title = data.title;
    this.agentData = data.agentData;
  }

  handleAgentFiltersFormCloseEvent() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  protected get showDataSourceClearIcon() {
    return !!this.form.controls['dataSourceId'].value;
  }

  ngOnInit() {
    if (!this.config) {
      this.config = {} as AgentFilterResult;
    }
    this.patchFormValues();
    this.http.get<TramsDataSourceModel[]>('dbov2/trams-data-source').subscribe(
      (data) => {
        this.datasources = data;
      },
      (error) => {
        console.error('Failed to fetch datasources', error);
      }
    );
  }

  patchFormValues() {
    const { agentName, agentCode, dataSourceId } = this.config;
    this.form.patchValue({
      agentName: agentName || null,
      agentCode: agentCode || null,
      dataSourceId: dataSourceId || null
    });
  }

  applyAgentFilters() {
    this.updateConfig();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }

  updateConfig() {
    this.config.agentName = this.form.get('agentName')?.value;
    this.config.agentCode = this.form.get('agentCode')?.value;
    this.config.dataSourceId = this.form.get('dataSourceId')?.value;
  }

  public clearAgentFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.config = {} as AgentFilterResult;
      this.form.reset();
    } else {
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof AgentFilterResult];
      this.config = temp;
    }
  }
}
